import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	id: PropTypes.number.isRequired,
	children: PropTypes.node.isRequired
};

const Item = ({ children }) => <div className="sortable-item">{ children }</div>;

Item.propTypes = propTypes;
export default Item;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/order-list/item.js